import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";

import type { HighlightView } from "../../model/Highlight";

const MULTIKILL = msg({
  message:
    "{count, plural, =2 {Double kill} =3 {Triple kill} =4 {Quadra kill} =5 {Penta kill} other {# kills}}",
});
const LANE_DOUBLE = msg`Lane double`;
const PARRIES = msg`Parry streak`;
const MIDBOSS = msg`Mid-boss fight`;
const ULTIMATE = msg({
  message: "{count, plural, other {#-man ultimate}}",
});

// Заголовок момента по главному виду: «Тройное убийство», «Двое на линии», «Ульта по троим».
export const useHighlightTitle = (): ((highlight: HighlightView) => string) => {
  const { i18n } = useLingui();
  return (highlight) => {
    switch (highlight.kinds[0]) {
      case "lane_double":
        return i18n._(LANE_DOUBLE);
      case "parries":
        return i18n._(PARRIES);
      case "midboss":
        return i18n._(MIDBOSS);
      case "ultimate":
        return i18n._({ ...ULTIMATE, values: { count: highlight.details.ult_hits.length } });
      default:
        return i18n._({ ...MULTIKILL, values: { count: highlight.details.victims.length } });
    }
  };
};
